// Sheheron ki list — City dropdown ke liye.
// Maqsad: "Lahore" / "lahore" / "LHR" ka masla khatam — sab ek hijje likhein,
// warna donor matching kaam nahi karti.

export const CITIES_BY_COUNTRY = {
  Pakistan: [
    'Karachi', 'Lahore', 'Islamabad', 'Rawalpindi', 'Faisalabad', 'Multan',
    'Peshawar', 'Quetta', 'Gujranwala', 'Sialkot', 'Hyderabad', 'Bahawalpur',
    'Sargodha', 'Sukkur', 'Larkana', 'Sheikhupura', 'Jhang', 'Gujrat',
    'Mardan', 'Kasur', 'Rahim Yar Khan', 'Sahiwal', 'Okara', 'Wah Cantt',
    'Dera Ghazi Khan', 'Mingora', 'Nawabshah', 'Chiniot', 'Kotri', 'Khanpur',
    'Hafizabad', 'Sadiqabad', 'Mirpur Khas', 'Burewala', 'Jacobabad',
    'Muzaffargarh', 'Abbottabad', 'Jhelum', 'Khanewal', 'Muzaffarabad',
    'Mirpur (AJK)', 'Gilgit', 'Skardu', 'Turbat', 'Gwadar', 'Attock',
    'Vehari', 'Nowshera', 'Kohat', 'Dadu', 'Bhakkar', 'Chakwal',
  ],
  India: ['Mumbai', 'Delhi', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Ahmedabad', 'Jaipur', 'Lucknow'],
  Bangladesh: ['Dhaka', 'Chittagong', 'Khulna', 'Rajshahi', 'Sylhet'],
  Indonesia: ['Jakarta', 'Surabaya', 'Bandung', 'Medan', 'Semarang', 'Makassar', 'Palembang', 'Yogyakarta'],
  Nigeria: ['Lagos', 'Kano', 'Ibadan', 'Abuja', 'Port Harcourt'],
  Philippines: ['Manila', 'Quezon City', 'Davao', 'Cebu City', 'Makati'],
  Vietnam: ['Ho Chi Minh City', 'Hanoi', 'Da Nang', 'Can Tho', 'Hai Phong'],
  Turkey: ['Istanbul', 'Ankara', 'Izmir', 'Bursa', 'Antalya'],
  Egypt: ['Cairo', 'Alexandria', 'Giza', 'Port Said'],
  'Saudi Arabia': ['Riyadh', 'Jeddah', 'Mecca', 'Medina', 'Dammam'],
  UAE: ['Dubai', 'Abu Dhabi', 'Sharjah', 'Ajman'],
  'United Kingdom': ['London', 'Birmingham', 'Manchester', 'Glasgow', 'Leeds'],
  'United States': ['New York', 'Los Angeles', 'Chicago', 'Houston', 'Phoenix'],
};

export function citiesFor(country) {
  if (country && CITIES_BY_COUNTRY[country]) return CITIES_BY_COUNTRY[country];
  return Object.values(CITIES_BY_COUNTRY).flat();
}

export const COUNTRIES = Object.keys(CITIES_BY_COUNTRY);
